export type BioQuestion = {
  id: string;
  question: string;
};

export type BioPreset = {
  id: string;
  text: string;
};

export const BIO_QUESTIONS: BioQuestion[] = [
  { id: "q-doing-tonight", question: "What are you doing tonight?" },
  { id: "q-go-to-drink", question: "What's your drink of choice?" },
  { id: "q-looking-for-tonight", question: "What are you looking for tonight?" },
];

export const BIO_PRESETS: BioPreset[] = [
  { id: "p-certified-fittie", text: "Certified Fittie" },
  { id: "p-buy-me-a-drink", text: "Buy me a drink?" },
  { id: "p-fit-and-fab", text: "Fit and Fab" },
];

export function getBioQuestion(id: string): BioQuestion | undefined {
  return BIO_QUESTIONS.find((item) => item.id === id);
}

export function getBioPreset(id: string): BioPreset | undefined {
  return BIO_PRESETS.find((item) => item.id === id);
}
